"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var rxjs_1 = require("rxjs");
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var compact_1 = __importDefault(require("lodash/compact"));
var get_1 = __importDefault(require("lodash/get"));
var sumBy_1 = __importDefault(require("lodash/sumBy"));
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var utils_1 = require("../utils");
var deviceAccess_1 = require("../../../hw/deviceAccess");
var signTransaction_1 = __importDefault(require("../../../hw/signTransaction"));
var jsHelpers_1 = require("../../../bridge/jsHelpers");
var currencies_1 = require("../../../currencies");
var account_1 = require("../../../account");
var pagination_1 = require("../../../pagination");
var errors_1 = require("@ledgerhq/errors");
var errors_2 = require("../../../errors");
var Tron_1 = require("../../../api/Tron");
var constants_1 = require("../constants");
var jsHelpers_2 = require("../../../bridge/jsHelpers");
var serialization_1 = require("../serialization");
var receive = (0, jsHelpers_2.makeAccountBridgeReceive)();
var signOperation = function (_a) {
    var account = _a.account, transaction = _a.transaction, deviceId = _a.deviceId;
    return (0, deviceAccess_1.withDevice)(deviceId)(function (transport) {
        return rxjs_1.Observable.create(function (o) {
            function main() {
                return __awaiter(this, void 0, void 0, function () {
                    var subAccount, isContractAddressRecipient, fee, balance, _a, getPreparedTransaction, preparedTransaction, signature, hash, getValue, value, operationType, resource, getExtra, extra, operation;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                subAccount = transaction.subAccountId && account.subAccounts
                                    ? account.subAccounts.find(function (sa) { return sa.id === transaction.subAccountId; })
                                    : null;
                                return [4 /*yield*/, (0, Tron_1.fetchTronContract)(transaction.recipient)];
                            case 1:
                                isContractAddressRecipient = (_b.sent()) !== undefined;
                                return [4 /*yield*/, getEstimatedFees(account, transaction, isContractAddressRecipient)];
                            case 2:
                                fee = _b.sent();
                                balance = subAccount
                                    ? subAccount.balance
                                    : bignumber_js_1.BigNumber.max(0, account.spendableBalance.minus(fee));
                                if (transaction.useAllAmount) {
                                    transaction = __assign({}, transaction); // transaction object must not be mutated
                                    transaction.amount = balance; // force the amount to be the max
                                }
                                _a = transaction.recipient &&
                                    transaction.mode === "send" &&
                                    subAccount &&
                                    subAccount.type === "TokenAccount" &&
                                    subAccount.token.tokenType === "trc20" &&
                                    !isContractAddressRecipient;
                                if (!_a) return [3 /*break*/, 4];
                                return [4 /*yield*/, (0, Tron_1.fetchTronAccount)(transaction.recipient)];
                            case 3:
                                _a = (_b.sent()).length === 0;
                                _b.label = 4;
                            case 4:
                                // send trc20 to a new account is forbidden by us (because it will not activate the account)
                                if (_a) {
                                    throw new errors_2.TronSendTrc20ToNewAccountForbidden();
                                }
                                getPreparedTransaction = function () {
                                    switch (transaction.mode) {
                                        case "freeze":
                                            return (0, Tron_1.freezeTronTransaction)(account, transaction);
                                        case "unfreeze":
                                            return (0, Tron_1.unfreezeTronTransaction)(account, transaction);
                                        case "vote":
                                            return (0, Tron_1.voteTronSuperRepresentatives)(account, transaction);
                                        case "claimReward":
                                            return (0, Tron_1.claimRewardTronTransaction)(account);
                                        default:
                                            return (0, Tron_1.createTronTransaction)(account, transaction, subAccount);
                                    }
                                };
                                return [4 /*yield*/, getPreparedTransaction()];
                            case 5:
                                preparedTransaction = _b.sent();
                                o.next({
                                    type: "device-signature-requested"
                                });
                                return [4 /*yield*/, (0, signTransaction_1["default"])(account.currency, transport, account.freshAddressPath, {
                                        rawDataHex: preparedTransaction.raw_data_hex,
                                        // only for trc10, we need to put the token ledger signature
                                        tokenSignature: subAccount &&
                                            subAccount.type === "TokenAccount" &&
                                            subAccount.token.id.includes("trc10")
                                            ? subAccount.token.ledgerSignature
                                            : undefined
                                    })];
                            case 6:
                                signature = _b.sent();
                                o.next({
                                    type: "device-signature-granted"
                                });
                                hash = preparedTransaction.txID;
                                getValue = function () {
                                    switch (transaction.mode) {
                                        case "send":
                                            return subAccount
                                                ? fee
                                                : new bignumber_js_1.BigNumber(transaction.amount || 0).plus(fee);
                                        case "claimReward": {
                                            var tronAcc = account;
                                            return tronAcc.tronResources
                                                ? tronAcc.tronResources.unwithdrawnReward
                                                : new bignumber_js_1.BigNumber(0);
                                        }
                                        default:
                                            return new bignumber_js_1.BigNumber(0);
                                    }
                                };
                                value = getValue();
                                operationType = (0, utils_1.getOperationTypefromMode)(transaction.mode);
                                resource = transaction.resource || "BANDWIDTH";
                                getExtra = function () {
                                    switch (transaction.mode) {
                                        case "freeze":
                                            return {
                                                frozenAmount: transaction.amount
                                            };
                                        case "unfreeze":
                                            return {
                                                unfreezeAmount: (0, get_1["default"])(account.tronResources, "frozen.".concat(resource.toLocaleLowerCase(), ".amount"), new bignumber_js_1.BigNumber(0))
                                            };
                                        case "vote":
                                            return {
                                                votes: transaction.votes
                                            };
                                        default:
                                            return undefined;
                                    }
                                };
                                extra = getExtra() || {};
                                operation = {
                                    id: "".concat(account.id, "-").concat(hash, "-").concat(operationType),
                                    hash: hash,
                                    // if it's a token op and there is no fee, this operation does not exist and is a "NONE"
                                    type: subAccount && value.eq(0) ? "NONE" : operationType,
                                    value: value,
                                    fee: fee,
                                    blockHash: null,
                                    blockHeight: null,
                                    senders: [account.freshAddress],
                                    recipients: [transaction.recipient],
                                    accountId: account.id,
                                    date: new Date(),
                                    extra: extra
                                };
                                if (subAccount) {
                                    /**
                                     * SEE FIXME ABOVE
                                     */
                                    operation.subOperations = [
                                        {
                                            id: "".concat(subAccount.id, "-").concat(hash, "-OUT"),
                                            hash: hash,
                                            type: "OUT",
                                            value: transaction.useAllAmount && subAccount
                                                ? subAccount.balance
                                                : new bignumber_js_1.BigNumber(transaction.amount || 0),
                                            fee: new bignumber_js_1.BigNumber(0),
                                            blockHash: null,
                                            blockHeight: null,
                                            senders: [account.freshAddress],
                                            recipients: [transaction.recipient],
                                            accountId: subAccount.id,
                                            date: new Date(),
                                            extra: {}
                                        },
                                    ];
                                }
                                o.next({
                                    type: "signed",
                                    signedOperation: {
                                        operation: operation,
                                        signature: signature,
                                        signatureRaw: preparedTransaction.raw_data,
                                        expirationDate: null
                                    }
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            }
            main().then(function () { return o.complete(); }, function (e) { return o.error(e); });
        });
    });
};
var broadcast = function (_a) {
    var _b = _a.signedOperation, signature = _b.signature, operation = _b.operation, signatureRaw = _b.signatureRaw;
    return __awaiter(void 0, void 0, void 0, function () {
        var transaction, submittedTransaction;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    transaction = {
                        raw_data: signatureRaw,
                        txID: operation.hash,
                        signature: [signature]
                    };
                    return [4 /*yield*/, (0, Tron_1.broadcastTron)(transaction)];
                case 1:
                    submittedTransaction = _c.sent();
                    if (submittedTransaction.result !== true) {
                        throw new Error(submittedTransaction.resultMessage);
                    }
                    return [2 /*return*/, operation];
            }
        });
    });
};
var getAccountShape = function (info, syncConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var blockHeight, tronAcc, accountId, defaultTronResources, acc, spendableBalance, cacheTransactionInfoById, operationsPageSize, txs, tronResources, balance, parentTxs, parentOperations, trc10Tokens, trc20Tokens, subAccounts, subOutOperationsWithFee, parentOpsAndSubOutOpsWithFee;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, Tron_1.fetchCurrentBlockHeight)()];
            case 1:
                blockHeight = _a.sent();
                return [4 /*yield*/, (0, Tron_1.fetchTronAccount)(info.address)];
            case 2:
                tronAcc = _a.sent();
                accountId = (0, account_1.encodeAccountId)({
                    type: "js",
                    version: "2",
                    currencyId: info.currency.id,
                    xpubOrAddress: info.address,
                    derivationMode: info.derivationMode
                });
                if (!(tronAcc.length === 0)) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, Tron_1.getTronResources)()];
            case 3:
                defaultTronResources = _a.sent();
                return [2 /*return*/, {
                        id: accountId,
                        blockHeight: blockHeight,
                        balance: new bignumber_js_1.BigNumber(0),
                        tronResources: defaultTronResources
                    }];
            case 4:
                acc = tronAcc[0];
                spendableBalance = acc.balance
                    ? new bignumber_js_1.BigNumber(acc.balance)
                    : new bignumber_js_1.BigNumber(0);
                cacheTransactionInfoById = __assign({}, (info.initialAccount &&
                    info.initialAccount.tronResources &&
                    info.initialAccount.tronResources
                        .cacheTransactionInfoById));
                operationsPageSize = Math.min(1000, (0, pagination_1.getOperationsPageSize)(info.initialAccount && info.initialAccount.id, syncConfig));
                return [4 /*yield*/, (0, Tron_1.fetchTronAccountTxs)(info.address, function (txs) { return txs.length < operationsPageSize; }, cacheTransactionInfoById)];
            case 5:
                txs = _a.sent();
                return [4 /*yield*/, (0, Tron_1.getTronResources)(acc, txs, cacheTransactionInfoById)];
            case 6:
                tronResources = _a.sent();
                balance = spendableBalance
                    .plus(tronResources.frozen.bandwidth
                    ? tronResources.frozen.bandwidth.amount
                    : new bignumber_js_1.BigNumber(0))
                    .plus(tronResources.frozen.energy
                    ? tronResources.frozen.energy.amount
                    : new bignumber_js_1.BigNumber(0))
                    .plus(tronResources.delegatedFrozen.bandwidth
                    ? tronResources.delegatedFrozen.bandwidth.amount
                    : new bignumber_js_1.BigNumber(0))
                    .plus(tronResources.delegatedFrozen.energy
                    ? tronResources.delegatedFrozen.energy.amount
                    : new bignumber_js_1.BigNumber(0));
                parentTxs = txs.filter(utils_1.isParentTx);
                parentOperations = (0, compact_1["default"])(parentTxs.map(function (tx) { return (0, utils_1.txInfoToOperation)(accountId, info.address, tx); }));
                trc10Tokens = (0, get_1["default"])(acc, "assetV2", []).map(function (_a) {
                    var key = _a.key, value = _a.value;
                    return ({
                        type: "trc10",
                        key: key,
                        value: value
                    });
                });
                trc20Tokens = (0, get_1["default"])(acc, "trc20", []).map(function (obj) {
                    var _a = __read(Object.entries(obj), 1), _b = __read(_a[0], 2), key = _b[0], value = _b[1];
                    return {
                        type: "trc20",
                        key: key,
                        value: value
                    };
                });
                subAccounts = (0, compact_1["default"])(trc10Tokens.concat(trc20Tokens).map(function (_a) {
                    var type = _a.type, key = _a.key, value = _a.value;
                    var _b = syncConfig.blacklistedTokenIds, blacklistedTokenIds = _b === void 0 ? [] : _b;
                    var tokenId = "tron/".concat(type, "/").concat(key);
                    var token = (0, cryptoassets_1.findTokenById)(tokenId);
                    if (!token || blacklistedTokenIds.includes(tokenId))
                        return;
                    var id = (0, account_1.encodeTokenAccountId)(accountId, token);
                    var tokenTxs = txs.filter(function (tx) { return tx.tokenId === key; });
                    var operations = (0, compact_1["default"])(tokenTxs.map(function (tx) { return (0, utils_1.txInfoToOperation)(id, info.address, tx); }));
                    var maybeExistingSubAccount = info.initialAccount &&
                        info.initialAccount.subAccounts &&
                        info.initialAccount.subAccounts.find(function (a) { return a.id === id; });
                    var balance = new bignumber_js_1.BigNumber(value);
                    var sub = {
                        type: "TokenAccount",
                        id: id,
                        starred: false,
                        parentId: accountId,
                        token: token,
                        balance: balance,
                        spendableBalance: balance,
                        operationsCount: operations.length,
                        operations: operations,
                        pendingOperations: maybeExistingSubAccount
                            ? maybeExistingSubAccount.pendingOperations
                            : [],
                        creationDate: operations.length > 0
                            ? operations[operations.length - 1].date
                            : new Date(),
                        swapHistory: maybeExistingSubAccount
                            ? maybeExistingSubAccount.swapHistory
                            : [],
                        balanceHistoryCache: account_1.emptyHistoryCache
                    };
                    return sub;
                }));
                subOutOperationsWithFee = (0, flatMap_1["default"])(subAccounts.map(function (s) { return s.operations; }))
                    .filter(function (o) { return o.type === "OUT" && o.fee.isGreaterThan(0); })
                    .map(function (o) { return (__assign(__assign({}, o), { accountId: accountId, value: o.fee, id: "".concat(accountId, "-").concat(o.hash, "-OUT") })); });
                parentOpsAndSubOutOpsWithFee = parentOperations
                    .concat(subOutOperationsWithFee)
                    .sort(function (a, b) { return b.date.valueOf() - a.date.valueOf(); });
                return [2 /*return*/, {
                        id: accountId,
                        balance: balance,
                        spendableBalance: spendableBalance,
                        operationsCount: parentOpsAndSubOutOpsWithFee.length,
                        operations: parentOpsAndSubOutOpsWithFee,
                        subAccounts: subAccounts,
                        tronResources: tronResources,
                        blockHeight: blockHeight
                    }];
        }
    });
}); };
var scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape: getAccountShape });
// the balance does not update straightaway so we should ignore recent operations if they are in pending for a bit
var preferPendingOperationsUntilBlockValidation = 35;
var postSync = function (initial, parent) {
    function evictRecentOpsIfPending(a) {
        a.pendingOperations.forEach(function (pending) {
            var i = a.operations.findIndex(function (o) { return o.id === pending.id; });
            if (i !== -1) {
                var diff = parent.blockHeight - (a.operations[i].blockHeight || 0);
                if (diff < preferPendingOperationsUntilBlockValidation) {
                    a.operations.splice(i, 1);
                }
            }
        });
    }
    evictRecentOpsIfPending(parent);
    parent.subAccounts && parent.subAccounts.forEach(evictRecentOpsIfPending);
    return parent;
};
var sync = (0, jsHelpers_1.makeSync)({ getAccountShape: getAccountShape, postSync: postSync });
var currencyBridge = {
    preload: function () { return __awaiter(void 0, void 0, void 0, function () {
        var superRepresentatives;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, Tron_1.getTronSuperRepresentatives)()];
                case 1:
                    superRepresentatives = _a.sent();
                    return [2 /*return*/, {
                            superRepresentatives: superRepresentatives
                        }];
            }
        });
    }); },
    hydrate: function (data) {
        if (!data || !data.superRepresentatives)
            return;
        var superRepresentatives = data.superRepresentatives;
        if (!superRepresentatives ||
            typeof superRepresentatives !== "object" ||
            !Array.isArray(superRepresentatives))
            return;
        (0, Tron_1.hydrateSuperRepresentatives)(superRepresentatives);
    },
    scanAccounts: scanAccounts
};
var createTransaction = function () { return ({
    family: "tron",
    amount: new bignumber_js_1.BigNumber(0),
    useAllAmount: false,
    mode: "send",
    duration: 3,
    recipient: "",
    networkInfo: null,
    resource: null,
    votes: []
}); };
var updateTransaction = function (t, patch) { return (__assign(__assign({}, t), patch)); };
// see : https://developers.tron.network/docs/bandwith#section-bandwidth-points-consumption
// 1. cost around 200 Bandwidth, if not enough check Free Bandwidth
// 2. If not enough, will cost some TRX
// 3. normal transfert cost around 0.002 TRX
var getFeesFromBandwidth = function (a, t) {
    var _a = (0, Tron_1.extractBandwidthInfo)(t.networkInfo), freeUsed = _a.freeUsed, freeLimit = _a.freeLimit, gainedUsed = _a.gainedUsed, gainedLimit = _a.gainedLimit;
    var available = freeLimit
        .minus(freeUsed)
        .plus(gainedLimit)
        .minus(gainedUsed);
    var estimatedBandwidthCost = (0, utils_1.getEstimatedBlockSize)(a, t);
    if (available.lt(estimatedBandwidthCost)) {
        return new bignumber_js_1.BigNumber(2000); // cost is around 0.002 TRX
    }
    return new bignumber_js_1.BigNumber(0); // no fee
};
// Special case: If activated an account, cost around 0.1 TRX
var getFeesFromAccountActivation = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var recipientAccount, _a, gainedUsed, gainedLimit, available, estimatedBandwidthCost;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, Tron_1.fetchTronAccount)(t.recipient)];
            case 1:
                recipientAccount = _b.sent();
                _a = (0, Tron_1.extractBandwidthInfo)(t.networkInfo), gainedUsed = _a.gainedUsed, gainedLimit = _a.gainedLimit;
                available = gainedLimit.minus(gainedUsed);
                estimatedBandwidthCost = (0, utils_1.getEstimatedBlockSize)(a, t);
                if (recipientAccount.length === 0 && available.lt(estimatedBandwidthCost)) {
                    return [2 /*return*/, constants_1.activationFees]; // cost is around 1 TRX
                }
                return [2 /*return*/, new bignumber_js_1.BigNumber(0)]; // no fee
        }
    });
}); };
var getEstimatedFees = function (a, t, isContract) { return __awaiter(void 0, void 0, void 0, function () {
    var feesFromAccountActivation, _a, feesFromBandwidth;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(t.mode === "send" && !isContract)) return [3 /*break*/, 2];
                return [4 /*yield*/, getFeesFromAccountActivation(a, t)];
            case 1:
                _a = _b.sent();
                return [3 /*break*/, 3];
            case 2:
                _a = new bignumber_js_1.BigNumber(0);
                _b.label = 3;
            case 3:
                feesFromAccountActivation = _a;
                if (feesFromAccountActivation.gt(0)) {
                    return [2 /*return*/, feesFromAccountActivation];
                }
                feesFromBandwidth = getFeesFromBandwidth(a, t);
                return [2 /*return*/, feesFromBandwidth];
        }
    });
}); };
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, family, mode, recipient, resource, votes, _a, useAllAmount, tokenAccount, account, isContractAddressRecipient, _b, _c, lowerCaseResource, now, expiredDatePath, expirationDate, superRepresentatives_1, isValidVoteCounts, isValidAddresses, totalVoteCount, tronPower, lastRewardOp, claimableRewardDate, estimatedFees, _d, balance, amount, amountSpent, totalSpent, energy, contractUserEnergyConsumption, fees;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                errors = {};
                warnings = {};
                family = t.family, mode = t.mode, recipient = t.recipient, resource = t.resource, votes = t.votes, _a = t.useAllAmount, useAllAmount = _a === void 0 ? false : _a;
                tokenAccount = !t.subAccountId
                    ? null
                    : a.subAccounts && a.subAccounts.find(function (ta) { return ta.id === t.subAccountId; });
                account = tokenAccount || a;
                return [4 /*yield*/, (0, Tron_1.fetchTronContract)(recipient)];
            case 1:
                isContractAddressRecipient = (_e.sent()) !== undefined;
                if (mode === "send" && !recipient) {
                    errors.recipient = new errors_1.RecipientRequired();
                }
                if (!["send", "freeze", "unfreeze"].includes(mode)) return [3 /*break*/, 8];
                if (!(recipient === a.freshAddress)) return [3 /*break*/, 2];
                errors.recipient = new errors_1.InvalidAddressBecauseDestinationIsAlsoSource();
                return [3 /*break*/, 8];
            case 2:
                _b = recipient;
                if (!_b) return [3 /*break*/, 4];
                return [4 /*yield*/, (0, Tron_1.validateAddress)(recipient)];
            case 3:
                _b = !(_e.sent());
                _e.label = 4;
            case 4:
                if (!_b) return [3 /*break*/, 5];
                errors.recipient = new errors_1.InvalidAddress(undefined, {
                    currencyName: a.currency.name
                });
                return [3 /*break*/, 8];
            case 5:
                _c = recipient &&
                    mode === "send" &&
                    account.type === "TokenAccount" &&
                    account.token.tokenType === "trc20" &&
                    !isContractAddressRecipient;
                if (!_c) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, Tron_1.fetchTronAccount)(recipient)];
            case 6:
                _c = (_e.sent()).length === 0;
                _e.label = 7;
            case 7:
                if (_c) {
                    // send trc20 to a new account is forbidden by us (because it will not activate the account)
                    errors.recipient = new errors_2.TronSendTrc20ToNewAccountForbidden();
                }
                _e.label = 8;
            case 8:
                if (mode === "unfreeze") {
                    lowerCaseResource = resource ? resource.toLowerCase() : "bandwidth";
                    now = new Date();
                    expiredDatePath = recipient
                        ? "tronResources.delegatedFrozen.".concat(lowerCaseResource, ".expiredAt")
                        : "tronResources.frozen.".concat(lowerCaseResource, ".expiredAt");
                    expirationDate = (0, get_1["default"])(a, expiredDatePath, undefined);
                    if (!expirationDate) {
                        if (resource === "BANDWIDTH") {
                            errors.resource = new errors_2.TronNoFrozenForBandwidth();
                        }
                        else {
                            errors.resource = new errors_2.TronNoFrozenForEnergy();
                        }
                    }
                    else if (now.getTime() < expirationDate.getTime()) {
                        errors.resource = new errors_2.TronUnfreezeNotExpired(undefined, {
                            until: expirationDate.toISOString()
                        });
                    }
                }
                if (!(mode === "vote")) return [3 /*break*/, 11];
                if (!(votes.length === 0)) return [3 /*break*/, 9];
                errors.vote = new errors_2.TronVoteRequired();
                return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, (0, Tron_1.getTronSuperRepresentatives)()];
            case 10:
                superRepresentatives_1 = _e.sent();
                isValidVoteCounts = votes.every(function (v) { return v.voteCount > 0; });
                isValidAddresses = votes.every(function (v) {
                    return superRepresentatives_1.some(function (s) { return s.address === v.address; });
                });
                if (!isValidAddresses) {
                    errors.vote = new errors_1.InvalidAddress();
                }
                else if (!isValidVoteCounts) {
                    errors.vote = new errors_2.TronInvalidVoteCount();
                }
                else {
                    totalVoteCount = (0, sumBy_1["default"])(votes, "voteCount");
                    tronPower = (a.tronResources && a.tronResources.tronPower) || 0;
                    if (totalVoteCount > tronPower) {
                        errors.vote = new errors_2.TronNotEnoughTronPower();
                    }
                }
                _e.label = 11;
            case 11:
                if (mode === "claimReward") {
                    lastRewardOp = account.operations.find(function (o) { return o.type === "REWARD"; });
                    claimableRewardDate = lastRewardOp
                        ? new Date(lastRewardOp.date.getTime() + 24 * 60 * 60 * 1000) // date + 24 hours
                        : new Date();
                    if (a.tronResources && a.tronResources.unwithdrawnReward.eq(0)) {
                        errors.reward = new errors_2.TronNoReward();
                    }
                    else if (lastRewardOp &&
                        claimableRewardDate.valueOf() > new Date().valueOf()) {
                        errors.reward = new errors_2.TronRewardNotAvailable("Reward is not claimable", {
                            until: claimableRewardDate.toISOString()
                        });
                    }
                }
                if (!(Object.entries(errors).length > 0)) return [3 /*break*/, 12];
                _d = new bignumber_js_1.BigNumber(0);
                return [3 /*break*/, 14];
            case 12: return [4 /*yield*/, getEstimatedFees(a, t, isContractAddressRecipient)];
            case 13:
                _d = _e.sent();
                _e.label = 14;
            case 14:
                estimatedFees = _d;
                balance = account.type === "Account"
                    ? bignumber_js_1.BigNumber.max(0, account.spendableBalance.minus(estimatedFees))
                    : account.balance;
                amount = useAllAmount ? balance : t.amount;
                amountSpent = ["send", "freeze"].includes(mode)
                    ? amount
                    : new bignumber_js_1.BigNumber(0);
                if (mode === "freeze" && amount.lt(constants_1.oneTrx)) {
                    errors.amount = new errors_2.TronInvalidFreezeAmount();
                }
                totalSpent = account.type === "Account" ? amountSpent.plus(estimatedFees) : amountSpent;
                if (!["send", "freeze"].includes(mode)) return [3 /*break*/, 16];
                if (amount.eq(0)) {
                    errors.amount = new errors_1.AmountRequired();
                }
                if (amountSpent.eq(0)) {
                    errors.amount = useAllAmount
                        ? new errors_1.NotEnoughBalance()
                        : new errors_1.AmountRequired();
                }
                else if (amount.gt(balance)) {
                    errors.amount = new errors_1.NotEnoughBalance();
                }
                else if (account.type === "TokenAccount" && estimatedFees.gt(a.balance)) {
                    errors.amount = new errors_1.NotEnoughBalance();
                }
                energy = (a.tronResources && a.tronResources.energy) || new bignumber_js_1.BigNumber(0);
                if (!(account.type === "TokenAccount" &&
                    account.token.tokenType === "trc20" &&
                    energy.lt(47619)) // temporary value corresponding to usdt trc20 energy
                ) return [3 /*break*/, 16]; // temporary value corresponding to usdt trc20 energy
                return [4 /*yield*/, (0, Tron_1.getContractUserEnergyRatioConsumption)(account.token.contractAddress)];
            case 15:
                contractUserEnergyConsumption = _e.sent();
                if (contractUserEnergyConsumption > 0) {
                    warnings.amount = new errors_2.TronNotEnoughEnergy();
                }
                _e.label = 16;
            case 16:
                if (!errors.recipient && estimatedFees.gt(0)) {
                    fees = (0, currencies_1.formatCurrencyUnit)((0, account_1.getAccountUnit)(a), estimatedFees, {
                        showCode: true,
                        disableRounding: true
                    });
                    warnings.fee = new errors_2.TronUnexpectedFees("Estimated fees", {
                        fees: fees
                    });
                }
                return [2 /*return*/, Promise.resolve({
                        errors: errors,
                        warnings: warnings,
                        amount: amountSpent,
                        estimatedFees: estimatedFees,
                        totalSpent: totalSpent,
                        family: family
                    })];
        }
    });
}); };
var estimateMaxSpendable = function (_a) {
    var account = _a.account, parentAccount = _a.parentAccount, transaction = _a.transaction;
    return __awaiter(void 0, void 0, void 0, function () {
        var mainAccount, fees, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
                    _b = getEstimatedFees;
                    _c = [mainAccount, __assign(__assign(__assign(__assign({}, createTransaction()), { subAccountId: account.type === "Account" ? null : account.id }), transaction), { recipient: (transaction === null || transaction === void 0 ? void 0 : transaction.recipient) || "0x0000000000000000000000000000000000000000", amount: new bignumber_js_1.BigNumber(0) })];
                    if (!(transaction && transaction.recipient)) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, Tron_1.fetchTronContract)(transaction.recipient)];
                case 1:
                    _d = (_e.sent()) !== undefined;
                    return [3 /*break*/, 3];
                case 2:
                    _d = false;
                    _e.label = 3;
                case 3: return [4 /*yield*/, _b.apply(void 0, _c.concat([_d]))];
                case 4:
                    fees = _e.sent();
                    return [2 /*return*/, account.type === "Account"
                            ? bignumber_js_1.BigNumber.max(0, account.spendableBalance.minus(fees))
                            : account.balance];
            }
        });
    });
};
var prepareTransaction = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var networkInfo, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = t.networkInfo;
                if (_a) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, Tron_1.getTronAccountNetwork)(a.freshAddress)];
            case 1:
                _a = (_b.sent());
                _b.label = 2;
            case 2:
                networkInfo = _a;
                return [2 /*return*/, t.networkInfo === networkInfo ? t : __assign(__assign({}, t), { networkInfo: networkInfo })];
        }
    });
}); };
var accountBridge = {
    createTransaction: createTransaction,
    updateTransaction: updateTransaction,
    prepareTransaction: prepareTransaction,
    getTransactionStatus: getTransactionStatus,
    estimateMaxSpendable: estimateMaxSpendable,
    sync: sync,
    receive: receive,
    signOperation: signOperation,
    broadcast: broadcast,
    assignFromAccountRaw: serialization_1.assignFromAccountRaw,
    assignToAccountRaw: serialization_1.assignToAccountRaw
};
exports["default"] = {
    currencyBridge: currencyBridge,
    accountBridge: accountBridge
};
//# sourceMappingURL=js.js.map